<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>系统管理>线路管理</p>
         <!-- <button @click="demo">切换</button> -->
         <div class="body">
             <div class="search">
                 <div class="block" id="container">
                    <span v-for="(item,index) in options" id="index" :key="index" @click="switchs(item)" class="seach-all" :class="{seachchange:changeblue==index}" > {{item.name}} </span>
                </div>
             </div>
         </div>
         <div class="info">
                <component :is="componentType"/>
         </div>
    </div>
</template>

<script>
import tours from '../Tours/Tours' //跟团列表
import toursRoute from '../Tours/ToursRoute' //跟团行程
import everDay from '../Tours/EverDay' //单天介绍
import apply from '../Tours/Apply' //报名须知
import price from '../Tours/Price' //费用说明
import priceInfo from '../Tours/PriceInfo' //费用规则
import prompt from '../Tours/Prompt' //温馨提示
import everCourse from '../Tours/EverCourse' //单天线路
import slide from '../Tours/Slide' //轮播图

import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('toursVip')

export default {
    data() {
      return {
        // component:'tours',
        options:[
            {id:0,name:'跟团行程',url:'toursRoute'},
            // {id:1,name:'单天介绍',url:'everDay'},
            {id:1,name:'报名须知',url:'apply'},
            {id:2,name:'费用说明',url:'price'},
            {id:3,name:'收费规则',url:'priceInfo'},
            {id:4,name:'温馨提示',url:'prompt'},
            {id:5,name:'轮播图片',url:'slide'},
        ],
        changeblue:'',
      }
    },
    components:{tours,toursRoute,apply,prompt,price,priceInfo,everDay,everCourse,slide},
    computed:{
      ...mapState({
         componentType:state=>state.componentType
      })
    },
    methods: {
        ...mapMutations(['alterComponentType']),
        switchs(item){
            this.alterComponentType(item.url)
            this.changeblue = item.id;
        }
    }
};
</script>

<style scoped>

.block{
    height: 50px;
}

.demonstration{
    line-height: 50px;
    width: 200px;
}

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.table{
    width: 50%;
}

.head th{
    line-height: 50px;
}

.info{
    margin-top: 1%;
    background-color: #FFFFFF;
}

.color{
    background-color: #0F86DA;
    width: 50px;
    height: 50px;
}


.seach-all {
    /* border-right: 1px solid #ffffff; */
    border-radius:25px;
    display: inline-block;
    margin-top: 10px;
    width: 180px;
    margin-left: 10px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-family: ArialMT;
    font-size: 18px;
    color: #ffffff;
    background-color: #dbe3eb;
  }

  .seach-all:last-child {
    border-right: none;
  }

  .seachchange {
    background-color: #409EFF;
  }

</style>


// WEBPACK FOOTER //
// src/components/Vip/Tours/ToursInfo.vue